// Component registry maps component names from DB to actual React components
import AppShowcase from './components/AppShowcase';
import WelcomeHero from './components/WelcomeHero';
import FeatureGrid from './components/FeatureGrid';
import GettingStarted from './components/GettingStarted';

const componentRegistry = {
	AppShowcase: AppShowcase,
	WelcomeHero: WelcomeHero,
	FeatureGrid: FeatureGrid,
	GettingStarted: GettingStarted
};

export default componentRegistry;
